var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 4.5C1.5 4.08579 1.83579 3.75 2.25 3.75H21.75C22.1642 3.75 22.5 4.08579 22.5 4.5V19.5C22.5 19.9142 22.1642 20.25 21.75 20.25H2.25C1.83579 20.25 1.5 19.9142 1.5 19.5V4.5ZM3 5.25V18.75H21V5.25H3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.25C7.5 9.07843 6.82843 9.75 6 9.75C5.17157 9.75 4.5 9.07843 4.5 8.25C4.5 7.42157 5.17157 6.75 6 6.75C6.82843 6.75 7.5 7.42157 7.5 8.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 14.25C22.5 14.6642 22.1642 15 21.75 15L2.25 15C1.83579 15 1.5 14.6642 1.5 14.25C1.5 13.8358 1.83579 13.5 2.25 13.5L21.75 13.5C22.1642 13.5 22.5 13.8358 22.5 14.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 13.5C15.4142 13.5 15.75 13.8358 15.75 14.25V18.75C15.75 19.1642 15.4142 19.5 15 19.5C14.5858 19.5 14.25 19.1642 14.25 18.75V14.25C14.25 13.8358 14.5858 13.5 15 13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.9796a2cb42c9c86268102fc78477e310.svg";
export { ForwardRef as ReactComponent };